import Vue from 'vue'
import App from './App.vue'
import Plugins from './plugins'
import router from './router'
import store from './store'
import 'iview/dist/styles/iview.css'
import iview from './iview/index'
import '@/assets/style.less'
import Components from '@/components';
import VueClipboard from 'vue-clipboard2'
import scroll from 'vue-seamless-scroll'
Vue.config.productionTip = false

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

//引入wysibb
import "wysibb/jquery.wysibb";
import wysibb from "wysibb";


Vue.use(Plugins)
Vue.use(iview)
Vue.use(wysibb)
Vue.use(Components)
Vue.use(VueClipboard)
Vue.use(scroll)


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
